const endpoints = {
  createRemunerationsCommission: (): string => `remuneration/commission`,
  showRemunerationCommission: (id: string): string =>
    `remuneration/commission/${id}`,
  inactivateRemunerationCommission: (id: string): string =>
    `remuneration/commission/inactivate/${id}`,
};

export default endpoints;
